import {
  CheckCircle2Icon,
  DatabaseIcon,
  HardDriveIcon,
  ServerIcon,
  TriangleAlertIcon,
} from 'lucide-react';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { useDegradedMode } from '@/lib/admin-queries';
import { strings } from '@/i18n/strings';

/**
 * Tizim holati.
 *
 * Ranglar mavzu o'zgaruvchilaridan (`success` / `warning`) olinadi, Tailwind ning tayyor
 * `emerald`/`amber` shkalasidan emas. Farqi shundaki, holat rangi panelning qolgan qismida
 * ham ishlatiladi (yorliqlar, ogohlantirishlar), va u bitta manbadan kelmasa ikkita "yashil"
 * paydo bo'ladi — bir xil ma'noda, ammo boshqa rangda.
 *
 * Har bir qatorda holat BIR MARTA aytiladi. Ilgari uni ikkita element takrorlardi — "Ishchi
 * holatda" degan matn va yonidagi "Online" yorlig'i — va shu ortiqcha yorliq xizmat nomini
 * siqib qo'yardi: to'rt ustunli tartibda "Ma'lumotlar bazasi (PostgreSQL)" "Ma'lumotlar b…"
 * ga aylanardi, ya'ni takror ma'lumot ASL ma'lumotni yeb qo'ygandi. Endi rangni matnning o'zi
 * va yonidagi nuqta olib yuradi.
 */
export function SystemHealthWidget() {
  const { data: degradedStatus } = useDegradedMode();
  const isDegraded = degradedStatus?.active ?? false;

  const services = [
    {
      name: strings.dashboard.healthDatabase,
      status: strings.dashboard.healthOperational,
      online: true,
      icon: DatabaseIcon,
    },
    {
      name: strings.dashboard.healthRedis,
      status: strings.dashboard.healthOperational,
      online: true,
      icon: ServerIcon,
    },
    {
      name: strings.dashboard.healthStorage,
      status: strings.dashboard.healthOperational,
      online: true,
      icon: HardDriveIcon,
    },
    {
      name: strings.dashboard.healthScraper,
      status: isDegraded ? strings.dashboard.healthDegraded : strings.dashboard.healthOperational,
      online: !isDegraded,
      icon: isDegraded ? TriangleAlertIcon : CheckCircle2Icon,
    },
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle>{strings.dashboard.systemHealthHeading}</CardTitle>
      </CardHeader>
      <CardContent className="motion-stagger grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
        {services.map((service) => {
          const Icon = service.icon;
          return (
            <div
              key={service.name}
              className="motion-lift border-border/70 flex min-w-0 items-center gap-3 rounded-lg border p-3.5"
            >
              <div
                className={cn(
                  'flex size-9 shrink-0 items-center justify-center rounded-md',
                  service.online
                    ? 'bg-success/12 text-success'
                    : 'bg-warning/20 text-warning-foreground dark:text-warning',
                )}
              >
                <Icon className="size-4" aria-hidden="true" />
              </div>

              <div className="min-w-0">
                <p className="truncate text-sm leading-tight font-medium">{service.name}</p>
                <p
                  className={cn(
                    'mt-0.5 flex items-center gap-1.5 text-xs',
                    service.online
                      ? 'text-success'
                      : 'text-warning-foreground dark:text-warning font-medium',
                  )}
                >
                  {/*
                    Jonli nuqta. Tarqaladigan halqa sekin (2 soniya) va bitta: efir kunida bu
                    ekran soatlab ochiq turadi, tez miltillash esa bir necha daqiqada
                    ko'rilmay qoladigan shovqinga aylanadi.
                  */}
                  <span
                    aria-hidden="true"
                    className={cn(
                      'size-1.5 shrink-0 rounded-full',
                      service.online ? 'bg-success motion-ping' : 'bg-warning',
                    )}
                  />
                  <span className="truncate">{service.status}</span>
                </p>
              </div>
            </div>
          );
        })}
      </CardContent>
    </Card>
  );
}
